import { RestrictionType, } from '../../GroupAccessRestriction';
export function restrictedByEvents(accessRestriction) {
    return (accessRestriction === null || accessRestriction === void 0 ? void 0 : accessRestriction.type) === RestrictionType.EVENTS;
}
export function restrictedByAdmin(accessRestriction) {
    return (accessRestriction === null || accessRestriction === void 0 ? void 0 : accessRestriction.type) === RestrictionType.ADMIN_APPROVAL;
}
export function getRestrictedEventIds(group) {
    var _a, _b;
    return (_b = (_a = group.accessRestriction) === null || _a === void 0 ? void 0 : _a.events) === null || _b === void 0 ? void 0 : _b.eventIds;
}
//# sourceMappingURL=index.js.map